export default __webpack_public_path__ + "static/media/ico_dotted_line_camera.33ca4324.png";